import type { Model } from '@patsnap/tahiti-core';
import type { Task } from '../types';

export const TaskModel = Symbol.for('TaskModel');

export interface TaskModel extends Model<Task> {}
